import React from "react";
// import { useStaticQuery, graphql } from "gatsby";
import RCPagination from "rc-pagination";
import locale from "rc-pagination/lib/locale/en_GB";

import Link from "../../commons/Link";
import Box from "../../commons/Box";

export default function Pagination({
  sx,
  itemCount,
  pageSize,
  current,
  pathname,
  ...otherProps
}) {
  // const { site } = useStaticQuery(query);
  // Let's hardcode this for now since website is in 1 language only

  // const [locale, setLocale] = React.useState();
  // React.useEffect(() => {
  //   import(
  //     `rc-pagination/lib/locale/${site.siteMetadata.language.replace("-", "_")}`
  //   ).then((locale) => setLocale(locale));
  // }, [site.siteMetadata.language]);

  const itemRender = React.useCallback(
    (i, type, element) => {
      const index = Math.floor(i);

      if (type === "page") {
        return (
          <Link to={index > 1 ? `/${pathname}/${index}` : `/${pathname}`}>
            {index}
          </Link>
        );
      }

      if (type === "jump-next" || type === "jump-prev") {
        return "…";
      }

      return element;
    },
    [pathname]
  );

  return (
    <Box
      sx={{
        ".rc-pagination-prev, .rc-pagination-next": {
          display: "none",
        },
        ul: {
          display: "flex",
          justifyContent: "center",
          listStyle: "none",
          p: 0,
        },
        li: {
          color: "gray.2",
          fontSize: [6, 8, 9],
          px: "0.3em",
        },
        ".rc-pagination-jump-prev, .rc-pagination-jump-next": {
          px: "0.1em",
        },
        ".rc-pagination-item-active a": {
          color: "black",
        },
        a: {
          "&:hover": {
            textDecorationColor: "transparent",
          },
        },
        ...sx,
      }}
    >
      <RCPagination
        total={itemCount}
        pageSize={pageSize}
        current={current}
        onChange={() => {}}
        itemRender={itemRender}
        locale={locale}
        hideOnSinglePage
      />
    </Box>
  );
}

// const query = graphql`
//   query Pagination {
//     site {
//       siteMetadata {
//         language
//       }
//     }
//   }
// `;
